<div id="emailContent" style="width: 700px; margin: 0 auto;"></div>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close (click)="cancel()">Cancel</button>
  <button  mat-raised-button color="primary" (click)="send()">Send</button>
</mat-dialog-actions>